import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferTransactionComponent } from './refer-transaction.component';
import { XIconModule } from '@app/dynamic-ui/x-icon/x-icon.module';



@NgModule({
  declarations: [
    ReferTransactionComponent
  ],
  imports: [
    CommonModule,
    XIconModule
  ]
})
export class ReferTransactionModule { }
